import { userService } from "../services";
import config from "../config/config";

export const PermissionControllerAction = {
  getLockPermissionsForTrips,
  saveLockPermissionsForTrips,
  getLockList,
  fetchAllDealersUsers,
  saveDealerCustomerPermissionsForTrips,
  getUserWiseGpsPermission,
  saveUserWiseGpsPermission,
  getAllFaqCategories,
  getAllFaqQuestionsByCategory,
  getAllFaqAnswersByQuestion,
  getAllFaqCategory,
  getAllFaqQuestions,
  getAllFaqAnswers,
  saveUpdateFaqCategory,
  saveUpdateFaqQuestion,
  saveUpdateFaqAnswer,
  getDealerCustomerWisePermissionsForTrips,
  getAllMasterPermissionsByType,
  getUserWiseMasterPermissionsByType,
  saveUserWiseMasterPermissionsByType,
  getAllExcises
};

async function getLockPermissionsForTrips(payload) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getLockPermissionsForTrips}`;
    const apiEndpoint = buildUrl(url, payload);
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getLockPermissionsForTrips res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveLockPermissionsForTrips(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveLockPermissionsForTrips
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveLockPermissionsForTrips res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getLockList({
  pageNo = 0,
  pageSize = 0,
  keyword = "",
  isActive = null,
  batteryCategory = null,
  availabilityStatus = null,
}) {
  const localData = JSON.parse(localStorage.getItem("data") || "{}");
  const userId = localData?.id;
  try {
    const apiEndpoint = `${JSON.parse(localStorage.getItem("config"))?.baseUrl}${config.apiName.LockGetAll}?pageNo=${pageNo}&pageSize=${pageSize}`;
    const response = await userService.post(apiEndpoint, {
      pageNo,
      pageSize,
      keyword,
      isActive,
      userId,
      batteryCategory,
      availabilityStatus,
    });
    if (response && response.data) return response.data;
    return null;
  } catch (error) {
    console.log("getLockList error", error);
    return null;
  }
}

async function fetchAllDealersUsers(payload) {
  try {
    // const name = JSON.parse(localStorage.getItem("data")).name;
    const companyId = JSON.parse(localStorage.getItem("data")).companyId;
    const apiEndpont = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.SubUsersList
    }?userType=${payload?.userType ? payload?.userType : ""}&companyId=${companyId}&pageNo=${
      payload.pageNo ? payload.pageNo : 0
    }&pageSize=${payload.pageSize ? payload.pageSize : 0}&email=${
      payload.email ? payload.email : ""
    }&name=${payload.name ? payload.name : ""}&forDropDown=${
      payload.forDropDown ? payload.forDropDown : null
    }`;

    const response = await userService.get(apiEndpont);
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (err) {
    console.log(err);
    return null;
  }
}

async function getDealerCustomerWisePermissionsForTrips(payload) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getDealerCustomerWisePermissionsForTrips}`;
    const apiEndpoint = buildUrl(url, payload);
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getDealerCustomerWisePermissionsForTrips res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveDealerCustomerPermissionsForTrips(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveDealerCustomerPermissionsForTrips
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveDealerCustomerPermissionsForTrips res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getUserWiseGpsPermission(payload) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getUserWiseGpsPermission}`;
    const apiEndpoint = buildUrl(url, payload);
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getUserWiseGpsPermission res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUserWiseGpsPermission(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveUserWiseGpsPermission
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveUserWiseGpsPermission res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getAllFaqCategories() {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getAllFaqCategories}`;

    let response = await userService.get(url);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getAllFaqCategories res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getAllFaqQuestionsByCategory(id) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getAllFaqQuestionsByCategory}/${id}`;

    let response = await userService.get(url);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getAllFaqQuestionsByCategory res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getAllFaqAnswersByQuestion(id) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getAllFaqAnswersByQuestion}/${id}`;

    let response = await userService.get(url);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getAllFaqAnswersByQuestion res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getAllFaqCategory() {
  try {
    let baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl || "";
    let url = `${baseUrl}${config.apiName.getAllFaqCategory}`;

    let response = await userService.get(url);
    if (response) {
      return response.data || response;
    }
    return null;
  } catch (error) {
    console.log("error getAllFaqCategory:", error);
    return null;
  }
}

async function getAllFaqQuestions(id) {
  try {
    let baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl || "";
    let url = `${baseUrl}${config.apiName.getAllFaqQuestions}/${id}`;

    let response = await userService.get(url);
    if (response) {
      return response.data || response;
    }
    return null;
  } catch (error) {
    console.log("error getAllFaqQuestions:", error);
    return null;
  }
}

async function getAllFaqAnswers(id) {
  try {
    let baseUrl = JSON.parse(localStorage.getItem("config"))?.baseUrl || "";
    let url = `${baseUrl}${config.apiName.getAllFaqAnswers}/${id}`;

    let response = await userService.get(url);
    if (response) {
      return response.data || response;
    }
    return null;
  } catch (error) {
    console.log("error getAllFaqAnswers:", error);
    return null;
  }
}

async function saveUpdateFaqCategory(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveUpdateFaqCategory
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveUpdateFaqCategory res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function saveUpdateFaqQuestion(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveUpdateFaqQuestion
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveUpdateFaqQuestion res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function saveUpdateFaqAnswer(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveUpdateFaqAnswer
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveUpdateFaqAnswer res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getAllMasterPermissionsByType(payload) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getAllMasterPermissionsByType}`;
    const apiEndpoint = buildUrl(url, payload);
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getAllMasterPermissionsByType res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getUserWiseMasterPermissionsByType(payload) {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getUserWiseMasterPermissionsByType}`;
    const apiEndpoint = buildUrl(url, payload);
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getUserWiseMasterPermissionsByType res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUserWiseMasterPermissionsByType(payload) {
  try {
    const apiEndPoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${
      config.apiName.saveUserWiseMasterPermissionsByType
    }`;
    const response = await userService.post(apiEndPoint, payload);
    if (response && (response.status === 200 || response.status === 201)) {
      return response;
    } else if (response && response.status === 208) {
      return response;
    } else if (response && response.status === 400) {
      console.log("saveUserWiseMasterPermissionsByType res: ", response);
      alert(response.data.message);
      return null;
    } else {
      return null;
    }
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function getAllExcises() {
  try {
    let url = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.getAllExcises}`;
    const apiEndpoint = url;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("getAllExcises res: ", response);
      alert(response.data.message);
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}
